
(function ($) {

  // eslint-disable-next-line max-statements
  function navClick(evt) {
    var navItem = $(evt.currentTarget);
    if (navItem.hasClass('active')) { return; }

    var pageNavForm = $('input[name="_page-nav-form"]');
    if (!pageNavForm) { return; }

    var pageNavFormPage = $('#' + pageNavForm.val() + '-page');
    if (!pageNavFormPage) { return; }

    var navCtx = navItem.attr('data-ctx');
    var page = navItem.attr('data-value');
    var navData = page;
    if ((typeof page !== 'undefined') && page.length) {
      pageNavFormPage.val(page);
    } else {
      var id = navItem.attr('id');
      navData = id;
      var curPageStr = $('#page-nav li.active').attr('data-value');
      var curPage = parseInt(curPageStr, 10);
      var direction = id === 'right' ? 1 : -1;
      pageNavFormPage.val(curPage + direction);
    }

    ux.traffic.click('mcx.help.serp.pagenav.click',
      [
        ['nav', navData],
        ['ctx', navCtx],
        ['plId', requestContext.plId]
      ]);
    $('#' + pageNavForm.val()).submit();
    return false;
  }

  $('#page-nav li').on('click', navClick);

}(jQuery));
